module.exports = __webpack_public_path__ + "static/logo-meiquer-star-bg-8e6eb8cb414362b53fea1076e5d9305d.png";